// English FAQ for Contact page
export const DEFAULT_FAQS_EN = [
  {
    question: "What's the easiest way to get to you in Råstrand, Lapland?",
    answer: [
      "The distance from Malmö to our house is about 1500 km.",
      "The fastest and most convenient way is by plane. A ticket to Lapland costs barely more than two full tanks of petrol and is highly recommended.",
      "We always pick up and drop off our guests at Skellefteå, Luleå or Lycksele airport."
    ]
  },
  {
    question: "How do I fly to you?",
    answer: [
      "Depending on where you live, fly to Arlanda in Stockholm.",
      "From there, take a domestic flight with Amapola to Lycksele (100 km from us). Transfer is included in the winter package and tickets are booked at amapola.nu.",
      "You can also fly to Skellefteå or Luleå and continue by rental car. These airports are further away but tickets can sometimes be very cheap. We are happy to help you find the best options."
    ]
  },
  {
    question: "Can I drive my own car to you?",
    answer: [
      "Yes, but make sure you have good winter tires. Be careful, as there are many wild animals on the roads.",
      "From Stockholm to Råstrand, it takes about 9–10 hours by car.",
      "You can easily find Råstrand by searching for 'Cold Experience Lapland' on Google Maps."
    ]
  },
  {
    question: "Are snowmobile clothes, boots, and helmets included?",
    answer: [
      "Yes, we provide outerwear. The snowmobile clothes are warm – you wear thermal underwear and soft clothes underneath."
    ]
  },
  {
    question: "What clothes should I bring?",
    answer: [
      "We recommend you pack:",
      "1. High-quality thermal underwear",
      "2. Regular socks",
      "3. Sweater or fleece jacket",
      "4. Warm fleece pants / soft trousers",
      "5. Warm wool socks",
      "6. Winter jacket or ski suit",
      "7. Winter boots / sturdy shoes",
      "8. Hat and balaclava to wear under the helmet",
      "9. Scarf",
      "10. Good gloves",
      "11. Sunglasses or ski goggles",
      "12. Swimwear",
      "Items 6 and 7 are used outdoors when not riding a snowmobile. On snowmobile tours, you get an overall, boots, and helmet.",
      "In Sweden, people take off their shoes indoors, so feel free to bring warm slippers or thick socks for indoor use."
    ]
  },
  {
    question: "Is there anything I don't need to bring?",
    answer: [
      "We provide bed linen, towels, bathrobes, and slippers.",
      "A hairdryer is available in the bathroom.",
      "Coffee, tea, water, and juice are included in the full board."
    ]
  },
  {
    question: "What is not included in the full board?",
    answer: [
      "Alcoholic beverages are not included. Bring cash if you want to buy any."
    ]
  },
  {
    question: "Do I need extra insurance?",
    answer: [
      "Yes, buy travel insurance that covers adventure activities.",
      "Also check that your health insurance is valid abroad and bring proof of insurance."
    ]
  },
  {
    question: "Do I need a special license for snowmobiles?",
    answer: [
      "No, a regular driver's license is enough.",
      "All drivers must have their license with them. Since you always drive together with our guide, it is sufficient that the guide has all necessary permits.",
      "Also check that your passport or ID is valid."
    ]
  },
  {
    question: "Can I use foreign currency in Sweden?",
    answer: [
      "No, you need to exchange to Swedish kronor (SEK) to shop with us or in the village store.",
      "Most other shops accept VISA and Mastercard."
    ]
  }
];
